export function computeAnalysisScore(answers, questions, typeMulti) {
  let score = 0;
  const questionsId = Object.keys(answers).filter((k) => answers[k] != null);
  // console.log('COUCOU questionsId', questionsId)
  for (let i = 0; i < questionsId.length; ++i) {
    const question = questions.find((q) => `${q.id}` === `${questionsId[i]}`);

    const answer = answers[questionsId[i]];
    // console.log('COUCOU question', question.options[answer])
    const current = question.options ? question.options[answer].value : answer;
    score += Number(current) * question.multi;
  }
  // console.log('score x 1e4', score)
  return Number(((score * typeMulti) / 10000).toFixed(2));
}
